import { Home } from '@/components/Home'
import { ErrorRoute } from '@/routes/ErrorRoute'
import { LoadingRoute } from '@/routes/LoadingRoute'
import { RootState } from '@/store'
import { DataProvider } from '@repo/ui/dataProvider'

export function BeneficiariesRoute() {
  return (
    <DataProvider
      errorComponent={<ErrorRoute />}
      loadingComponent={<LoadingRoute />}
      selectors={[
        (state: RootState) => state.beneficiary.beneficiary,
        (state: RootState) => state.beneficiary.organization,
        (state: RootState) => state.beneficiary.chatSessions,
      ]}
      render={(beneficiary, organization, chatSessions) => (
        <Home
          beneficiary={beneficiary}
          organization={organization}
          chatSessions={chatSessions}
        />
      )}
    />
  )
}
